
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import YouTubeVideoGrid from '@/components/ui-custom/YouTubeVideoGrid';
import { Instagram, Youtube } from 'lucide-react';

const SocialMediaFeeds = () => {
  const [activeTab, setActiveTab] = useState('youtube');

  return (
    <div className="mb-16">
      <Tabs defaultValue="youtube" onValueChange={setActiveTab} className="w-full">
        <div className="flex justify-between items-end mb-6">
          <div>
            <h2 className="heading-lg text-white mb-2">ExodusADV</h2>
            <p className="text-adv-lightGray">Follow our latest adventures and updates</p>
          </div>
          
          <TabsList className="bg-adv-charcoal">
            <TabsTrigger 
              value="youtube" 
              className="data-[state=active]:bg-adv-orange data-[state=active]:text-white"
            >
              <Youtube size={16} className="mr-2" /> YouTube
            </TabsTrigger>
            <TabsTrigger 
              value="instagram" 
              className="data-[state=active]:bg-adv-orange data-[state=active]:text-white"
            >
              <Instagram size={16} className="mr-2" /> Instagram
            </TabsTrigger>
          </TabsList>
        </div>
        
        <TabsContent value="youtube" className="mt-0">
          <YouTubeVideoGrid maxVideos={6} />
        </TabsContent>
        
        <TabsContent value="instagram" className="mt-0">
          <div className="text-center py-16 bg-adv-charcoal/30 rounded-lg">
            <Instagram size={48} className="text-adv-lightGray mx-auto mb-4 opacity-50" />
            <h3 className="text-xl font-medium mb-2 text-white">Instagram content coming soon</h3>
            <p className="text-adv-lightGray mb-6">Follow @ExodusADV on Instagram for the latest updates</p>
            <a 
              href="https://instagram.com/ExodusADV" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary bg-pink-600 hover:bg-pink-700 inline-flex items-center"
            >
              <Instagram size={18} className="mr-2" />
              Follow on Instagram
            </a>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SocialMediaFeeds;
